(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function initializeContactSpamGuard(scope) {
    scope.querySelectorAll('form[data-spk-contact-guard="true"]').forEach((form) => {
      if (form.dataset.spkGuardReady === 'true') return;
      form.dataset.spkGuardReady = 'true';

      const startedAt = performance.now();
      const honeypot = form.querySelector('[data-spk-honeypot]');
      const message = form.querySelector('[data-spk-guard-message]');
      let hasHumanInput = false;

      form.addEventListener('input', (event) => {
        if (event.target !== honeypot) hasHumanInput = true;
      });

      form.addEventListener('submit', (event) => {
        const submittedTooQuickly = performance.now() - startedAt < 2200;
        const trapWasFilled = honeypot && honeypot.value.trim() !== '';

        if (trapWasFilled || submittedTooQuickly || !hasHumanInput) {
          event.preventDefault();
          if (message) {
            message.textContent = 'Wacht een ogenblik en controleer de ingevulde gegevens.';
            message.hidden = false;
          }
          if (trapWasFilled) form.reset();
          return;
        }
      });
    });
  }

  initializeContactSpamGuard(document);
  document.addEventListener('shopify:section:load', (event) => initializeContactSpamGuard(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class SmidFloerPriceFilters extends HTMLElement {
    connectedCallback() {
      const url = new URL(location.href);
      let changed = false;
      for (const name of [...url.searchParams.keys()]) {
        if (name.startsWith('filter.v.price.')) { url.searchParams.delete(name); changed = true; }
      }
      if (['price-ascending', 'price-descending'].includes(url.searchParams.get('sort_by'))) {
        url.searchParams.set('sort_by', 'title-ascending');
        changed = true;
      }
      if (changed) {
        url.searchParams.delete('page');
        location.replace(url.href);
      }
    }
  }
  if (!customElements.get('smid-floer-price-filters')) customElements.define('smid-floer-price-filters', SmidFloerPriceFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["smid-product-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('smid-colour-picker')) {
    customElements.define('smid-colour-picker', class extends HTMLElement {
      connectedCallback() {
        const select = this.querySelector('select');
        if (!select || select.dataset.bound) return;
        select.dataset.bound = 'true';
        select.addEventListener('change', () => {
          const destination = new URL(select.value, window.location.origin);
          if (destination.origin === window.location.origin) window.location.assign(destination.href);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
